import * as React from 'react';
import { Button as SliceButton, IButtonProps } from '@lce/slice';
import styled from 'styled-components';
import { mediaQueries } from '@lce/slice';

interface IBlackButton extends IButtonProps {
  href: string;
  children: React.ReactNode;
}

export const SimpleBlackButton: React.FC<IButtonProps> = styled(SliceButton)`
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.mrEaves};
  font-weight: bold;
  font-size: 18px;
  line-height: 1em;
  padding: 16px 24px;
  border-radius: 12px;
  border: none;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  transition-duration: 0.3s;
  transition-property: color, background-color;
  background-color: ${({ theme }) => theme.colors.black};
  color: ${({ theme }) => theme.colors.white};

  :hover {
    background-color: ${({ theme }) => theme.colors.black};
  }

  ${mediaQueries[0]} {
    font-size: 24px;
    padding: 20px 40px;
  }
`;

const BlackButton: React.FC<IBlackButton> = ({ children, href, ...props }) => (
  <SimpleBlackButton data-testid="BlackButton" {...props} onClick={ () => { window.location.assign(href) } }>{ children }</SimpleBlackButton>
);

BlackButton.displayName = 'BlackButton';

export default BlackButton;
